import { BannerType } from '@/app/entities/Banner'
import { useBannersMutations } from '@/app/hooks/useBannersMutations'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/view/components/ui/alert-dialog'
import { Button } from '@/view/components/ui/button'

import { useState } from 'react'
import { Trash } from 'lucide-react'
import { useBanners } from '@/app/hooks/useBanners'
interface DeleteBannerProps {
  bannerIndex: number
  type: BannerType
}

export const DeleteBanner = ({ bannerIndex, type }: DeleteBannerProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { banners } = useBanners(type)
  const { updateBanners, isUpdating } = useBannersMutations(type)

  const handleDelete = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    event.preventDefault()

    if (!banners) return
    const newBanners = banners.banners.filter(
      (_, index) => index !== bannerIndex,
    )
    await updateBanners(newBanners)
    setIsOpen(false)
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    event.preventDefault()
    setIsOpen(true)
  }

  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    event.preventDefault()
    setIsOpen(false)
  }

  const handleStopPropagation = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
    event.preventDefault()
  }

  return (
    <>
      <Button
        className="h-8 w-8"
        variant="destructive"
        size="icon"
        onClick={handleClick}
      >
        <Trash className="h-4 w-4" />
      </Button>

      <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
        <AlertDialogContent
          onOpenAutoFocus={(event) => event.preventDefault()}
          onClick={handleStopPropagation}
        >
          <AlertDialogHeader>
            <AlertDialogTitle>Excluir Banner</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza que deseja excluir este banner?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel asChild>
              <Button
                disabled={isUpdating}
                variant="outline"
                onClick={handleClose}
              >
                Cancelar
              </Button>
            </AlertDialogCancel>
            <AlertDialogAction
              disabled={isUpdating}
              onClick={handleDelete}
              className="text-white"
            >
              Excluir
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
